'use client';

import Slider from 'react-slick';
import config from 'config';
import { defaultSettings } from 'constant';
import Image, { StaticImageData } from 'next/image';

import { Box, Link } from '@chakra-ui/react';

const {
  dashboard: { sidebar }
} = config;

const PromoBanner = () => (
  <Box
    w='100%'
    justifyContent='flex-end'
    alignSelf='center'
    marginBottom='20px'
    sx={{
      '*': {
        outline: 'none'
      }
    }}
  >
    <Slider
      {...defaultSettings}
      fade
      speed={2000}
      adaptiveHeight
      variableWidth={false}
    >
      {sidebar?.promoBanners.map(
        ({ img, url }: { img: StaticImageData; url: string }) => (
          <Box w='100%' h='100%' key={img.toString()} position='relative'>
            <Box
              as={Image}
              alt={`banner-${url}`}
              src={img}
              priority
              sx={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                borderRadius: 6
              }}
            />
            {url && (
              <Link
                href={url}
                position='absolute'
                top={0}
                left={0}
                bottom={0}
                right={0}
                cursor='pointer'
                target='_blank'
                outline='none !important'
                draggable={false}
              />
            )}
          </Box>
        )
      )}
    </Slider>
  </Box>
);

export default PromoBanner;
